import { Link } from 'react-router-dom';
import { topRatedMovies } from '@/mocks/movies';

export default function PopularRanking() {
  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-center justify-between mb-5 md:mb-6">
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
          热播排行
        </h3>
        <span className="text-sm text-foreground-500">评分最高TOP 10</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {topRatedMovies.map((movie, index) => (
          <Link
            key={movie.id}
            to={`/movie/${movie.id}`}
            className="group flex items-center gap-4 p-3 rounded-xl bg-background-100 border border-background-300/30 hover:border-primary-500/50 transition-all duration-300 cursor-pointer"
          >
            <div className="relative shrink-0">
              <span className={`absolute -top-2 -left-2 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold text-background-950 ${
                index < 3 ? 'bg-primary-500' : 'bg-secondary-500'
              }`}>
                {index + 1}
              </span>
            </div>
            <div className="relative w-12 h-16 rounded-lg overflow-hidden shrink-0">
              <img
                src={movie.poster}
                alt={movie.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-heading font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors truncate">
                {movie.title}
              </h4>
              <div className="flex items-center gap-2 mt-1">
                <div className="flex items-center gap-1">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-primary-500 text-[10px]"></i>
                  </div>
                  <span className="text-xs font-semibold text-foreground-300">{movie.rating}</span>
                </div>
                <span className="text-xs text-foreground-600">{movie.category}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}